export const parseClientData = (payload) => {
  if (!payload) {
    return { name: "-", address: "-", code: "", clientUniqueId: "" };
  }
  try {
    return typeof payload === "string" ? JSON.parse(payload) : payload;
  } catch (error) {
    console.error("Erreur lors du parsing des données client:", error);
    return { name: "-", address: "-", code: "", clientUniqueId: "" };
  }
};

/** Display producer name with settings unique ID when available: "NAME (ref)". */
export const formatProducerNameWithUniqueId = (client) => {
  const name = String(client?.name || "").trim();
  if (!name || name === "-") return name || "-";
  const uniqueId = String(client?.clientUniqueId || "").trim();
  if (!uniqueId) return name;
  return `${name} (${uniqueId})`;
};

export const buildWasteCategoryOptions = (wasteCategoryList) => {
  return wasteCategoryList.map((item) => ({
    key: item._id,
    value: JSON.stringify({
      id: item._id,
      wasteCategoryName: item.label,
      wasteCategoryCode: item.wasteCodeFull,
      wasteCategoryValue: item.value,
      wasteCategoryAuthorizedMaterial: item.authorizedMaterial,
      wasteCategoryDensity: item.density,
    }),
    label: item.label,
  }));
};
